(() => {
  const findQtyComponent = (outside) => {
    // same container: next quantity selector
    const parent = outside.closest('.product-form-buttons') || outside.parentElement;
    return parent?.querySelector('quantity-selector-component, cart-quantity-selector-component');
  };

  const init = (outside) => {
    if (!outside || outside.__vfInit) return;
    outside.__vfInit = true;

    const comp = findQtyComponent(outside);
    if (!comp) return;

    const input = comp.querySelector('input[ref="quantityInput"]');
    const toggleBtn = outside.querySelector('[data-vf-qty-toggle]');
    const presetsWrap = outside.querySelector('[data-vf-qty-presets]');
    const btns = presetsWrap ? Array.from(presetsWrap.querySelectorAll('[data-qty]')) : [];

    if (!input || !toggleBtn || btns.length === 0) return;

    const clamp = (n) => {
      const min = parseInt(input.getAttribute('min') || '1', 10);
      const maxAttr = input.getAttribute('max');
      const max = maxAttr ? parseInt(maxAttr, 10) : null;
      let v = Math.max(min, parseInt(n, 10) || min);
      if (max !== null) v = Math.min(max, v);
      return v;
    };

    const setActive = (qty) => {
      btns.forEach(b => b.classList.toggle('is-active', b.dataset.qty === String(qty)));
    };

    const applyQty = (qty) => {
      const v = clamp(qty);
      input.value = String(v);
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
      input.dispatchEvent(new Event('blur', { bubbles: true }));
      setActive(v);
    };

    const setMode = (mode) => {
      const manual = mode === 'manual';

      comp.classList.toggle('is-manual', manual);
      comp.classList.toggle('is-presets', !manual);

      // Outside UI swap
      presetsWrap.style.display = manual ? 'none' : '';
      toggleBtn.textContent = manual ? 'Mengenrabatt wählen' : 'Eigene Anzahl eingeben';

      if (manual) {
        input.style.opacity = '';
        input.style.pointerEvents = '';
        input.style.width = '';
        input.focus();
        input.select?.();
      } else {
        setActive(clamp(input.value));
      }
    };

    // default presets
    setMode('presets');
    setActive(clamp(input.value));

    btns.forEach(b => b.addEventListener('click', () => {
      if (comp.classList.contains('is-manual')) return;
      applyQty(b.dataset.qty);
    }));

    toggleBtn.addEventListener('click', (e) => {
      e.preventDefault();
      setMode(comp.classList.contains('is-manual') ? 'presets' : 'manual');
    });

    input.addEventListener('input', () => setActive(clamp(input.value)));
  };

  const scan = () => {
    document.querySelectorAll('[data-vf-qty-outside]').forEach(init);
  };

  scan();
  document.addEventListener('shopify:section:load', scan);
  new MutationObserver(scan).observe(document.documentElement, { childList: true, subtree: true });
})();
